// This file is auto-generated by @hey-api/openapi-ts

import {
  createClient,
  createConfig,
  type Options,
  formDataBodySerializer,
} from "@hey-api/client-fetch";
import type {
  GetVersionError,
  GetVersionResponse,
  PostCouponRedeemData,
  PostCouponRedeemError,
  PostCouponRedeemResponse,
  PostCouponCreateVideoAnnotationDaypassData,
  PostCouponCreateVideoAnnotationDaypassError,
  PostCouponCreateVideoAnnotationDaypassResponse,
  PostCouponCreateVideoAnnotationDaypassQrData,
  PostCouponCreateVideoAnnotationDaypassQrError,
  PostCouponCreateVideoAnnotationDaypassQrResponse,
  GetMachinesSearchData,
  GetMachinesSearchError,
  GetMachinesSearchResponse,
  GetMachinesSearchAuraData,
  GetMachinesSearchAuraError,
  GetMachinesSearchAuraResponse,
  GetMachinesSearchTaggingData,
  GetMachinesSearchTaggingError,
  GetMachinesSearchTaggingResponse,
  GetMachinesSearchRegionListError,
  GetMachinesSearchRegionListResponse,
  GetMachinesSearchRegionListAuraError,
  GetMachinesSearchRegionListAuraResponse,
  PostMachinesUpdateStatusData,
  PostMachinesUpdateStatusError,
  PostMachinesUpdateStatusResponse,
  PostMachinesUpdateGroupsByGroupByActionData,
  PostMachinesUpdateGroupsByGroupByActionError,
  PostMachinesUpdateGroupsByGroupByActionResponse,
  PostMachinesRegisterData,
  PostMachinesRegisterError,
  PostMachinesRegisterResponse,
  GetMachinesByMachineUuidGamesData,
  GetMachinesByMachineUuidGamesError,
  GetMachinesByMachineUuidGamesResponse,
  PostMachinesUpdateFieldImageData,
  PostMachinesUpdateFieldImageError,
  PostMachinesUpdateFieldImageResponse,
  GetMachinesByMachineUuidOwnerOrgsData,
  GetMachinesByMachineUuidOwnerOrgsError,
  GetMachinesByMachineUuidOwnerOrgsResponse,
  PostStripeWebhookData,
  PostStripeWebhookError,
  PostStripeWebhookResponse,
  PostLiveGrantWsData,
  PostLiveGrantWsError,
  PostLiveGrantWsResponse,
  GetHistoricRecentData,
  GetHistoricRecentError,
  GetHistoricRecentResponse,
  PostDataSensorData,
  PostDataSensorError,
  PostDataSensorResponse,
  PostDataSensorBackfillData,
  PostDataSensorBackfillError,
  PostDataSensorBackfillResponse,
  PostDataTagData,
  PostDataTagError,
  PostDataTagResponse,
  PostDataTeamSwapData,
  PostDataTeamSwapError,
  PostDataTeamSwapResponse,
  PostDataTeamSwapSmartData,
  PostDataTeamSwapSmartError,
  PostDataTeamSwapSmartResponse,
  PostDataNoTeamSwapData,
  PostDataNoTeamSwapError,
  PostDataNoTeamSwapResponse,
  PostDataNoTeamSwapSmartData,
  PostDataNoTeamSwapSmartError,
  PostDataNoTeamSwapSmartResponse,
  GetMeError,
  GetMeResponse,
  PostMeError,
  PostMeResponse,
  PostMeUpdateNameData,
  PostMeUpdateNameError,
  PostMeUpdateNameResponse,
  PostMeDeleteError,
  PostMeDeleteResponse,
  GetMeFeaturesError,
  GetMeFeaturesResponse,
  GetMeVisibilityGroupsTeamsError,
  GetMeVisibilityGroupsTeamsResponse,
  GetMeOrganizationsError,
  GetMeOrganizationsResponse,
  PostJournalData,
  PostJournalError,
  PostJournalResponse,
  PostUserCreateData,
  PostUserCreateError,
  PostUserCreateResponse,
  PostUsersByUserIdEditData,
  PostUsersByUserIdEditError,
  PostUsersByUserIdEditResponse,
  GetUsersInternalData,
  GetUsersInternalError,
  GetUsersInternalResponse,
  PostStripeCheckoutData,
  PostStripeCheckoutError,
  PostStripeCheckoutResponse,
  GetReportsVisibilityGroupsError,
  GetReportsVisibilityGroupsResponse,
  GetReportsPlayersSearchData,
  GetReportsPlayersSearchError,
  GetReportsPlayersSearchResponse,
  GetReportsSearchData,
  GetReportsSearchError,
  GetReportsSearchResponse,
  GetReportsDownloadData,
  GetReportsDownloadError,
  GetReportsDownloadResponse,
  GetReportsDownloadRawData,
  GetReportsDownloadRawError,
  GetReportsDownloadRawResponse,
  GetTeamsSearchData,
  GetTeamsSearchError,
  GetTeamsSearchResponse,
  GetTeamsTeamidSearchData,
  GetTeamsTeamidSearchError,
  GetTeamsTeamidSearchResponse,
  GetTeamsByTeamExternalIdTrendsData,
  GetTeamsByTeamExternalIdTrendsError,
  GetTeamsByTeamExternalIdTrendsResponse,
  PostRostersByRosterIdDeleteData,
  PostRostersByRosterIdDeleteError,
  PostRostersByRosterIdDeleteResponse,
  PostRostersByRosterIdEditNameData,
  PostRostersByRosterIdEditNameError,
  PostRostersByRosterIdEditNameResponse,
  PostRostersByRosterIdEditData,
  PostRostersByRosterIdEditError,
  PostRostersByRosterIdEditResponse,
  PostRostersByRosterIdRemovePlayerByPlayerExternalIdData,
  PostRostersByRosterIdRemovePlayerByPlayerExternalIdError,
  PostRostersByRosterIdRemovePlayerByPlayerExternalIdResponse,
  GetPlayersSearchData,
  GetPlayersSearchError,
  GetPlayersSearchResponse,
  GetPlayersByPlayerExternalIdData,
  GetPlayersByPlayerExternalIdError,
  GetPlayersByPlayerExternalIdResponse,
  GetPlayersByPlayerIdLatestGameData,
  GetPlayersByPlayerIdLatestGameError,
  GetPlayersByPlayerIdLatestGameResponse,
  GetPlayersByPlayerIdStatsData,
  GetPlayersByPlayerIdStatsError,
  GetPlayersByPlayerIdStatsResponse,
  GetPlayersByPlayerExternalIdAvailablePitchTypesData,
  GetPlayersByPlayerExternalIdAvailablePitchTypesError,
  GetPlayersByPlayerExternalIdAvailablePitchTypesResponse,
  GetPlayersByPlayerExternalIdGamesDataData,
  GetPlayersByPlayerExternalIdGamesDataError,
  GetPlayersByPlayerExternalIdGamesDataResponse,
  GetCompetitionLevelsByCompetitionLevelStatsData,
  GetCompetitionLevelsByCompetitionLevelStatsError,
  GetCompetitionLevelsByCompetitionLevelStatsResponse,
  PostRostersUnofficialUploadData,
  PostRostersUnofficialUploadError,
  PostRostersUnofficialUploadResponse,
  GetRostersUnofficialDownloadData,
  GetRostersUnofficialDownloadError,
  GetRostersUnofficialDownloadResponse,
  PostGameStartData,
  PostGameStartError,
  PostGameStartResponse,
  GetGameActiveData,
  GetGameActiveError,
  GetGameActiveResponse,
  PostGameActiveLineupsData,
  PostGameActiveLineupsError,
  PostGameActiveLineupsResponse,
  PostGameByGameIdSubstituteData,
  PostGameByGameIdSubstituteError,
  PostGameByGameIdSubstituteResponse,
  PostGameByGameIdEndData,
  PostGameByGameIdEndError,
  PostGameByGameIdEndResponse,
  PostGameByGameIdEditTimesData,
  PostGameByGameIdEditTimesError,
  PostGameByGameIdEditTimesResponse,
  GetGameByGameIdCsvData,
  GetGameByGameIdCsvError,
  GetGameByGameIdCsvResponse,
  GetGameByGameIdEventsData,
  GetGameByGameIdEventsError,
  GetGameByGameIdEventsResponse,
  PostGameByGameIdReportData,
  PostGameByGameIdReportError,
  PostGameByGameIdReportResponse,
  GetOrganizationsByOrgIdUsersData,
  GetOrganizationsByOrgIdUsersError,
  GetOrganizationsByOrgIdUsersResponse,
  GetOrganizationsByOrgIdMachinesData,
  GetOrganizationsByOrgIdMachinesError,
  GetOrganizationsByOrgIdMachinesResponse,
  GetOrganizationsByOrgIdOfficialTeamData,
  GetOrganizationsByOrgIdOfficialTeamError,
  GetOrganizationsByOrgIdOfficialTeamResponse,
  PostOrganizationsByOrgIdAssociateMachinesData,
  PostOrganizationsByOrgIdAssociateMachinesError,
  PostOrganizationsByOrgIdAssociateMachinesResponse,
  PostOrganizationsByOrgIdAssociateOfficialTeamsData,
  PostOrganizationsByOrgIdAssociateOfficialTeamsError,
  PostOrganizationsByOrgIdAssociateOfficialTeamsResponse,
  PostOrganizationsByOrgIdDeleteData,
  PostOrganizationsByOrgIdDeleteError,
  PostOrganizationsByOrgIdDeleteResponse,
  PostOrganizationsByOrgIdVerifyData,
  PostOrganizationsByOrgIdVerifyError,
  PostOrganizationsByOrgIdVerifyResponse,
  GetOrganizationsSearchData,
  GetOrganizationsSearchError,
  GetOrganizationsSearchResponse,
  GetOrganizationsError,
  GetOrganizationsResponse,
  PostOrganizationsCreateData,
  PostOrganizationsCreateError,
  PostOrganizationsCreateResponse,
  PostOrganizationsByOrgIdEditData,
  PostOrganizationsByOrgIdEditError,
  PostOrganizationsByOrgIdEditResponse,
  GetOrganizationsByOrgIdBillingPaymentMethodData,
  GetOrganizationsByOrgIdBillingPaymentMethodError,
  GetOrganizationsByOrgIdBillingPaymentMethodResponse,
  PostOrganizationsByOrgIdBillingPaymentMethodData,
  PostOrganizationsByOrgIdBillingPaymentMethodError,
  PostOrganizationsByOrgIdBillingPaymentMethodResponse,
  PostOrganizationsByOrgIdBillingSetupIntentData,
  PostOrganizationsByOrgIdBillingSetupIntentError,
  PostOrganizationsByOrgIdBillingSetupIntentResponse,
  PostOrganizationsByOrgIdPlayersByPlayerIdDeleteData,
  PostOrganizationsByOrgIdPlayersByPlayerIdDeleteError,
  PostOrganizationsByOrgIdPlayersByPlayerIdDeleteResponse,
  PostUsersInvitationsCreateData,
  PostUsersInvitationsCreateError,
  PostUsersInvitationsCreateResponse,
  GetUsersInvitationsByTokenCodeData,
  GetUsersInvitationsByTokenCodeError,
  GetUsersInvitationsByTokenCodeResponse,
  PostUsersInvitationsByTokenCodeRedeemData,
  PostUsersInvitationsByTokenCodeRedeemError,
  PostUsersInvitationsByTokenCodeRedeemResponse,
  GetInvitationsOrganizationsUnverifiedError,
  GetInvitationsOrganizationsUnverifiedResponse,
  PostRostersByRosterIdPlayersData,
  PostRostersByRosterIdPlayersError,
  PostRostersByRosterIdPlayersResponse,
  PostOrganizationsByOrgIdPlayersByPlayerExternalIdEditData,
  PostOrganizationsByOrgIdPlayersByPlayerExternalIdEditError,
  PostOrganizationsByOrgIdPlayersByPlayerExternalIdEditResponse,
  GetAuthoritiesPublicError,
  GetAuthoritiesPublicResponse,
  GetTeamsByTeamExternalIdLeaderboardData,
  GetTeamsByTeamExternalIdLeaderboardError,
  GetTeamsByTeamExternalIdLeaderboardResponse,
  PostBalltrackerByMachineUuidChallengeData,
  PostBalltrackerByMachineUuidChallengeError,
  PostBalltrackerByMachineUuidChallengeResponse,
  GetBalltrackerByMachineUuidBlockedData,
  GetBalltrackerByMachineUuidBlockedError,
  GetBalltrackerByMachineUuidBlockedResponse,
  PostBalltrackerByMachineUuidBlockedData,
  PostBalltrackerByMachineUuidBlockedError,
  PostBalltrackerByMachineUuidBlockedResponse,
  DeleteBalltrackerByMachineUuidBlockedData,
  DeleteBalltrackerByMachineUuidBlockedError,
  DeleteBalltrackerByMachineUuidBlockedResponse,
  GetBalltrackerByMachineUuidStatTrackingData,
  GetBalltrackerByMachineUuidStatTrackingError,
  GetBalltrackerByMachineUuidStatTrackingResponse,
  PostBalltrackerByMachineUuidStatTrackingData,
  PostBalltrackerByMachineUuidStatTrackingError,
  PostBalltrackerByMachineUuidStatTrackingResponse,
  DeleteBalltrackerByMachineUuidStatTrackingData,
  DeleteBalltrackerByMachineUuidStatTrackingError,
  DeleteBalltrackerByMachineUuidStatTrackingResponse,
  GetBalltrackerByMachineUuidUmpireAssistData,
  GetBalltrackerByMachineUuidUmpireAssistError,
  GetBalltrackerByMachineUuidUmpireAssistResponse,
  PostBalltrackerByMachineUuidUmpireAssistData,
  PostBalltrackerByMachineUuidUmpireAssistError,
  PostBalltrackerByMachineUuidUmpireAssistResponse,
  DeleteBalltrackerByMachineUuidUmpireAssistData,
  DeleteBalltrackerByMachineUuidUmpireAssistError,
  DeleteBalltrackerByMachineUuidUmpireAssistResponse,
  GetBalltrackerByMachineUuidUnifiedData,
  GetBalltrackerByMachineUuidUnifiedError,
  GetBalltrackerByMachineUuidUnifiedResponse,
  PostBalltrackerByMachineUuidUnifiedData,
  PostBalltrackerByMachineUuidUnifiedError,
  PostBalltrackerByMachineUuidUnifiedResponse,
  GetBalltrackerByMachineUuidStrikeZoneData,
  GetBalltrackerByMachineUuidStrikeZoneError,
  GetBalltrackerByMachineUuidStrikeZoneResponse,
  PostBalltrackerByMachineUuidStrikeZoneData,
  PostBalltrackerByMachineUuidStrikeZoneError,
  PostBalltrackerByMachineUuidStrikeZoneResponse,
  GetBalltrackerStrikeZoneBySportData,
  GetBalltrackerStrikeZoneBySportError,
  GetBalltrackerStrikeZoneBySportResponse,
  GetScheduleData,
  GetScheduleError,
  GetScheduleResponse,
  GetScheduleByScheduleUuidData,
  GetScheduleByScheduleUuidError,
  GetScheduleByScheduleUuidResponse,
  PostScheduleExternalData,
  PostScheduleExternalError,
  PostScheduleExternalResponse,
  PostScheduleInternalData,
  PostScheduleInternalError,
  PostScheduleInternalResponse,
} from "./types.gen";

export const client = createClient(createConfig());

/**
 * The responding API revision
 */
export const getVersion = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetVersionResponse,
    GetVersionError,
    ThrowOnError
  >({
    ...options,
    url: "/version",
  });
};

/**
 * Redeems a code string (Code strings are the content from a QR code)
 */
export const postCouponRedeem = <ThrowOnError extends boolean = false>(
  options: Options<PostCouponRedeemData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostCouponRedeemResponse,
    PostCouponRedeemError,
    ThrowOnError
  >({
    ...options,
    url: "/coupon/redeem",
  });
};

/**
 * Creates and returns a redeemable coupon code
 */
export const postCouponCreateVideoAnnotationDaypass = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostCouponCreateVideoAnnotationDaypassData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostCouponCreateVideoAnnotationDaypassResponse,
    PostCouponCreateVideoAnnotationDaypassError,
    ThrowOnError
  >({
    ...options,
    url: "/coupon/create/video-annotation/daypass",
  });
};

/**
 * Creates and returns a redeemable QR coupon
 */
export const postCouponCreateVideoAnnotationDaypassQr = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostCouponCreateVideoAnnotationDaypassQrData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostCouponCreateVideoAnnotationDaypassQrResponse,
    PostCouponCreateVideoAnnotationDaypassQrError,
    ThrowOnError
  >({
    ...options,
    url: "/coupon/create/video-annotation/daypass/qr",
  });
};

/**
 * Machine information retrieval using various query methods
 */
export const getMachinesSearch = <ThrowOnError extends boolean = false>(
  options?: Options<GetMachinesSearchData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetMachinesSearchResponse,
    GetMachinesSearchError,
    ThrowOnError
  >({
    ...options,
    url: "/machines/search",
  });
};

/**
 * Machine information retrieval using various query methods
 */
export const getMachinesSearchAura = <ThrowOnError extends boolean = false>(
  options?: Options<GetMachinesSearchAuraData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetMachinesSearchAuraResponse,
    GetMachinesSearchAuraError,
    ThrowOnError
  >({
    ...options,
    url: "/machines/search/aura",
  });
};

/**
 * Machine information retrieval for machines the invoking user can tag
 */
export const getMachinesSearchTagging = <ThrowOnError extends boolean = false>(
  options?: Options<GetMachinesSearchTaggingData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetMachinesSearchTaggingResponse,
    GetMachinesSearchTaggingError,
    ThrowOnError
  >({
    ...options,
    url: "/machines/search/tagging",
  });
};

/**
 * Machine region information retrieval for Aura sites
 */
export const getMachinesSearchRegionList = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetMachinesSearchRegionListResponse,
    GetMachinesSearchRegionListError,
    ThrowOnError
  >({
    ...options,
    url: "/machines/search/region-list",
  });
};

/**
 * Machine region information retrieval
 */
export const getMachinesSearchRegionListAura = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetMachinesSearchRegionListAuraResponse,
    GetMachinesSearchRegionListAuraError,
    ThrowOnError
  >({
    ...options,
    url: "/machines/search/region-list/aura",
  });
};

/**
 * Update machine status which shows up in machine searches
 */
export const postMachinesUpdateStatus = <ThrowOnError extends boolean = false>(
  options: Options<PostMachinesUpdateStatusData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostMachinesUpdateStatusResponse,
    PostMachinesUpdateStatusError,
    ThrowOnError
  >({
    ...options,
    url: "/machines/update/status",
  });
};

/**
 * Update machine visibility groups by adding or removing
 */
export const postMachinesUpdateGroupsByGroupByAction = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostMachinesUpdateGroupsByGroupByActionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostMachinesUpdateGroupsByGroupByActionResponse,
    PostMachinesUpdateGroupsByGroupByActionError,
    ThrowOnError
  >({
    ...options,
    url: "/machines/update/groups/{group}/{action}",
  });
};

/**
 * Insert machine information for later retrieval
 */
export const postMachinesRegister = <ThrowOnError extends boolean = false>(
  options: Options<PostMachinesRegisterData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostMachinesRegisterResponse,
    PostMachinesRegisterError,
    ThrowOnError
  >({
    ...options,
    url: "/machines/register",
  });
};

/**
 * List games for a specific machine
 * Retrieves a list of games associated with a specific machine.
 */
export const getMachinesByMachineUuidGames = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetMachinesByMachineUuidGamesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetMachinesByMachineUuidGamesResponse,
    GetMachinesByMachineUuidGamesError,
    ThrowOnError
  >({
    ...options,
    url: "/machines/{machine_uuid}/games",
  });
};

/**
 * Upload field image(s) for a machine
 * Uploads a field image (JPG or PNG) for a specified machine. Images are stored in blob storage and a reference is saved to the machine record.
 *
 */
export const postMachinesUpdateFieldImage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostMachinesUpdateFieldImageData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostMachinesUpdateFieldImageResponse,
    PostMachinesUpdateFieldImageError,
    ThrowOnError
  >({
    ...options,
    ...formDataBodySerializer,
    headers: {
      "Content-Type": null,
      ...options?.headers,
    },
    url: "/machines/update/field-image",
  });
};

/**
 * Get organizations with active passes for a machine
 * Retrieves organizations that have active machine passes for a specific machine at a point in time. Non-admin users only see organizations they are members of.
 */
export const getMachinesByMachineUuidOwnerOrgs = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetMachinesByMachineUuidOwnerOrgsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetMachinesByMachineUuidOwnerOrgsResponse,
    GetMachinesByMachineUuidOwnerOrgsError,
    ThrowOnError
  >({
    ...options,
    url: "/machines/{machine_uuid}/owner-orgs",
  });
};

/**
 * Create a new daypass for a user from a stripe webhook call
 */
export const postStripeWebhook = <ThrowOnError extends boolean = false>(
  options: Options<PostStripeWebhookData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostStripeWebhookResponse,
    PostStripeWebhookError,
    ThrowOnError
  >({
    ...options,
    url: "/stripe-webhook",
  });
};

/**
 * Generates a live data websocket
 */
export const postLiveGrantWs = <ThrowOnError extends boolean = false>(
  options: Options<PostLiveGrantWsData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostLiveGrantWsResponse,
    PostLiveGrantWsError,
    ThrowOnError
  >({
    ...options,
    url: "/live/grant-ws",
  });
};

/**
 * Get recent events from a machine
 */
export const getHistoricRecent = <ThrowOnError extends boolean = false>(
  options: Options<GetHistoricRecentData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetHistoricRecentResponse,
    GetHistoricRecentError,
    ThrowOnError
  >({
    ...options,
    url: "/historic/recent",
  });
};

/**
 * Interface for BallTracker to push up data
 */
export const postDataSensor = <ThrowOnError extends boolean = false>(
  options: Options<PostDataSensorData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostDataSensorResponse,
    PostDataSensorError,
    ThrowOnError
  >({
    ...options,
    url: "/data/sensor",
  });
};

/**
 * Interface for BallTracker to push up data
 */
export const postDataSensorBackfill = <ThrowOnError extends boolean = false>(
  options: Options<PostDataSensorBackfillData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostDataSensorBackfillResponse,
    PostDataSensorBackfillError,
    ThrowOnError
  >({
    ...options,
    url: "/data/sensor/backfill",
  });
};

/**
 * Interface for Tag Client to submit tag data
 */
export const postDataTag = <ThrowOnError extends boolean = false>(
  options: Options<PostDataTagData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostDataTagResponse,
    PostDataTagError,
    ThrowOnError
  >({
    ...options,
    url: "/data/tag",
  });
};

/**
 * Swaps the home and away sides of the game active on a machine: teams, team names, team colors, lineups, and substitution sides. The game is also marked as having validated teams. Permissioned on the requesting user being able to tag on the machine. The updated game is pushed over WebSocket and a gameTeamSwap event broker message is emitted.
 *
 */
export const postDataTeamSwap = <ThrowOnError extends boolean = false>(
  options: Options<PostDataTeamSwapData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostDataTeamSwapResponse,
    PostDataTeamSwapError,
    ThrowOnError
  >({
    ...options,
    url: "/data/team-swap",
  });
};

/**
 * Same as POST /data/team-swap, permissioned on the machine being a Smart Park with live access at the given time rather than on the requesting user.
 *
 */
export const postDataTeamSwapSmart = <ThrowOnError extends boolean = false>(
  options: Options<PostDataTeamSwapSmartData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostDataTeamSwapSmartResponse,
    PostDataTeamSwapSmartError,
    ThrowOnError
  >({
    ...options,
    url: "/data/team-swap/smart",
  });
};

/**
 * Confirms the home and away sides of the game active on a machine as-is, marking the game as having validated teams without swapping anything. Permissioned on the requesting user being able to tag on the machine. The updated game is pushed over WebSocket and a gameNoTeamSwap event broker message is emitted.
 *
 */
export const postDataNoTeamSwap = <ThrowOnError extends boolean = false>(
  options: Options<PostDataNoTeamSwapData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostDataNoTeamSwapResponse,
    PostDataNoTeamSwapError,
    ThrowOnError
  >({
    ...options,
    url: "/data/no-team-swap",
  });
};

/**
 * Same as POST /data/no-team-swap, permissioned on the machine being a Smart Park with live access at the given time rather than on the requesting user.
 *
 */
export const postDataNoTeamSwapSmart = <ThrowOnError extends boolean = false>(
  options: Options<PostDataNoTeamSwapSmartData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostDataNoTeamSwapSmartResponse,
    PostDataNoTeamSwapSmartError,
    ThrowOnError
  >({
    ...options,
    url: "/data/no-team-swap/smart",
  });
};

/**
 * Returns the user information of the logged in user
 */
export const getMe = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetMeResponse,
    GetMeError,
    ThrowOnError
  >({
    ...options,
    url: "/me",
  });
};

/**
 * Create the user if they do not currently exist or return the db record of the user if they do
 */
export const postMe = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostMeResponse,
    PostMeError,
    ThrowOnError
  >({
    ...options,
    url: "/me",
  });
};

/**
 * Update the family name or given name of a user in B2C
 */
export const postMeUpdateName = <ThrowOnError extends boolean = false>(
  options: Options<PostMeUpdateNameData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostMeUpdateNameResponse,
    PostMeUpdateNameError,
    ThrowOnError
  >({
    ...options,
    url: "/me/update-name",
  });
};

/**
 * Delete the user from the users table, if they exist.
 */
export const postMeDelete = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostMeDeleteResponse,
    PostMeDeleteError,
    ThrowOnError
  >({
    ...options,
    url: "/me/delete",
  });
};

/**
 * Returns the features currently available to the logged in user
 */
export const getMeFeatures = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetMeFeaturesResponse,
    GetMeFeaturesError,
    ThrowOnError
  >({
    ...options,
    url: "/me/features",
  });
};

/**
 * Returns the teams' visibility groups of the logged in user
 */
export const getMeVisibilityGroupsTeams = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetMeVisibilityGroupsTeamsResponse,
    GetMeVisibilityGroupsTeamsError,
    ThrowOnError
  >({
    ...options,
    url: "/me/visibility-groups/teams",
  });
};

/**
 * Returns the organizations the logged in user is part of
 */
export const getMeOrganizations = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetMeOrganizationsResponse,
    GetMeOrganizationsError,
    ThrowOnError
  >({
    ...options,
    url: "/me/organizations",
  });
};

/**
 * Send the body and params to the audit logs, associated to the current user
 */
export const postJournal = <ThrowOnError extends boolean = false>(
  options?: Options<PostJournalData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostJournalResponse,
    PostJournalError,
    ThrowOnError
  >({
    ...options,
    url: "/journal",
  });
};

/**
 * Create user
 */
export const postUserCreate = <ThrowOnError extends boolean = false>(
  options: Options<PostUserCreateData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostUserCreateResponse,
    PostUserCreateError,
    ThrowOnError
  >({
    ...options,
    url: "/user/create",
  });
};

/**
 * Edit user names and org roles
 */
export const postUsersByUserIdEdit = <ThrowOnError extends boolean = false>(
  options: Options<PostUsersByUserIdEditData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostUsersByUserIdEditResponse,
    PostUsersByUserIdEditError,
    ThrowOnError
  >({
    ...options,
    url: "/users/{user_id}/edit",
  });
};

/**
 * Gets a list of internal users
 */
export const getUsersInternal = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsersInternalData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetUsersInternalResponse,
    GetUsersInternalError,
    ThrowOnError
  >({
    ...options,
    url: "/users/internal",
  });
};

/**
 * Create stripe checkout session
 */
export const postStripeCheckout = <ThrowOnError extends boolean = false>(
  options?: Options<PostStripeCheckoutData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostStripeCheckoutResponse,
    PostStripeCheckoutError,
    ThrowOnError
  >({
    ...options,
    url: "/stripe/checkout",
  });
};

/**
 * Get list of visibility groups
 */
export const getReportsVisibilityGroups = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetReportsVisibilityGroupsResponse,
    GetReportsVisibilityGroupsError,
    ThrowOnError
  >({
    ...options,
    url: "/reports/visibility-groups",
  });
};

/**
 * Get list of players
 */
export const getReportsPlayersSearch = <ThrowOnError extends boolean = false>(
  options: Options<GetReportsPlayersSearchData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetReportsPlayersSearchResponse,
    GetReportsPlayersSearchError,
    ThrowOnError
  >({
    ...options,
    url: "/reports/players-search",
  });
};

/**
 * Get list of reports
 */
export const getReportsSearch = <ThrowOnError extends boolean = false>(
  options: Options<GetReportsSearchData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetReportsSearchResponse,
    GetReportsSearchError,
    ThrowOnError
  >({
    ...options,
    url: "/reports/search",
  });
};

/**
 * Get specified stamped report
 */
export const getReportsDownload = <ThrowOnError extends boolean = false>(
  options: Options<GetReportsDownloadData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetReportsDownloadResponse,
    GetReportsDownloadError,
    ThrowOnError
  >({
    ...options,
    url: "/reports/download",
  });
};

/**
 * Get raw link to PDF in blob storage
 */
export const getReportsDownloadRaw = <ThrowOnError extends boolean = false>(
  options: Options<GetReportsDownloadRawData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetReportsDownloadRawResponse,
    GetReportsDownloadRawError,
    ThrowOnError
  >({
    ...options,
    url: "/reports/download-raw",
  });
};

/**
 * Get list of teams
 */
export const getTeamsSearch = <ThrowOnError extends boolean = false>(
  options: Options<GetTeamsSearchData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetTeamsSearchResponse,
    GetTeamsSearchError,
    ThrowOnError
  >({
    ...options,
    url: "/teams/search",
  });
};

/**
 * Get the team documents with the given external team id, without requiring a visibility group. Returns an empty list when none match.
 *
 */
export const getTeamsTeamidSearch = <ThrowOnError extends boolean = false>(
  options: Options<GetTeamsTeamidSearchData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetTeamsTeamidSearchResponse,
    GetTeamsTeamidSearchError,
    ThrowOnError
  >({
    ...options,
    url: "/teams/teamid/search",
  });
};

/**
 * Get team trends and statistical metrics comparing season averages to recent performance
 */
export const getTeamsByTeamExternalIdTrends = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetTeamsByTeamExternalIdTrendsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetTeamsByTeamExternalIdTrendsResponse,
    GetTeamsByTeamExternalIdTrendsError,
    ThrowOnError
  >({
    ...options,
    url: "/teams/{team_external_id}/trends",
  });
};

/**
 * Deletes an unofficial roster
 */
export const postRostersByRosterIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostRostersByRosterIdDeleteData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostRostersByRosterIdDeleteResponse,
    PostRostersByRosterIdDeleteError,
    ThrowOnError
  >({
    ...options,
    url: "/rosters/{roster_id}/delete",
  });
};

/**
 * Edit the name of a roster
 */
export const postRostersByRosterIdEditName = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostRostersByRosterIdEditNameData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostRostersByRosterIdEditNameResponse,
    PostRostersByRosterIdEditNameError,
    ThrowOnError
  >({
    ...options,
    url: "/rosters/{roster_id}/edit-name",
  });
};

/**
 * Edit roster name, parent name, and/or update player jersey numbers
 */
export const postRostersByRosterIdEdit = <ThrowOnError extends boolean = false>(
  options: Options<PostRostersByRosterIdEditData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostRostersByRosterIdEditResponse,
    PostRostersByRosterIdEditError,
    ThrowOnError
  >({
    ...options,
    url: "/rosters/{roster_id}/edit",
  });
};

/**
 * Remove a player from a roster
 */
export const postRostersByRosterIdRemovePlayerByPlayerExternalId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostRostersByRosterIdRemovePlayerByPlayerExternalIdData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).post<
    PostRostersByRosterIdRemovePlayerByPlayerExternalIdResponse,
    PostRostersByRosterIdRemovePlayerByPlayerExternalIdError,
    ThrowOnError
  >({
    ...options,
    url: "/rosters/{roster_id}/remove-player/{player_external_id}",
  });
};

/**
 * Get list of teams
 */
export const getPlayersSearch = <ThrowOnError extends boolean = false>(
  options: Options<GetPlayersSearchData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetPlayersSearchResponse,
    GetPlayersSearchError,
    ThrowOnError
  >({
    ...options,
    url: "/players/search",
  });
};

/**
 * Get player details by ID
 * Retrieves detailed information about a player using their external ID.
 */
export const getPlayersByPlayerExternalId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPlayersByPlayerExternalIdData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetPlayersByPlayerExternalIdResponse,
    GetPlayersByPlayerExternalIdError,
    ThrowOnError
  >({
    ...options,
    url: "/players/{player_external_id}",
  });
};

/**
 * Get latest game data for a specific player
 */
export const getPlayersByPlayerIdLatestGame = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPlayersByPlayerIdLatestGameData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetPlayersByPlayerIdLatestGameResponse,
    GetPlayersByPlayerIdLatestGameError,
    ThrowOnError
  >({
    ...options,
    url: "/players/{player_id}/latest-game",
  });
};

/**
 * Get player stats for a specific date range
 */
export const getPlayersByPlayerIdStats = <ThrowOnError extends boolean = false>(
  options: Options<GetPlayersByPlayerIdStatsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetPlayersByPlayerIdStatsResponse,
    GetPlayersByPlayerIdStatsError,
    ThrowOnError
  >({
    ...options,
    url: "/players/{player_id}/stats",
  });
};

/**
 * Get available pitch types for a player
 */
export const getPlayersByPlayerExternalIdAvailablePitchTypes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPlayersByPlayerExternalIdAvailablePitchTypesData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).get<
    GetPlayersByPlayerExternalIdAvailablePitchTypesResponse,
    GetPlayersByPlayerExternalIdAvailablePitchTypesError,
    ThrowOnError
  >({
    ...options,
    url: "/players/{player_external_id}/available-pitch-types",
  });
};

export const getPlayersByPlayerExternalIdGamesData = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPlayersByPlayerExternalIdGamesDataData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetPlayersByPlayerExternalIdGamesDataResponse,
    GetPlayersByPlayerExternalIdGamesDataError,
    ThrowOnError
  >({
    ...options,
    url: "/players/{player_external_id}/games-data",
  });
};

/**
 * Get competition level stats for a specific date range
 */
export const getCompetitionLevelsByCompetitionLevelStats = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetCompetitionLevelsByCompetitionLevelStatsData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).get<
    GetCompetitionLevelsByCompetitionLevelStatsResponse,
    GetCompetitionLevelsByCompetitionLevelStatsError,
    ThrowOnError
  >({
    ...options,
    url: "/competition-levels/{competition_level}/stats",
  });
};

/**
 * Upload an unofficial roster CSV
 */
export const postRostersUnofficialUpload = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostRostersUnofficialUploadData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostRostersUnofficialUploadResponse,
    PostRostersUnofficialUploadError,
    ThrowOnError
  >({
    ...options,
    ...formDataBodySerializer,
    headers: {
      "Content-Type": null,
      ...options?.headers,
    },
    url: "/rosters/unofficial/upload",
  });
};

/**
 * Download an unofficial roster CSV
 */
export const getRostersUnofficialDownload = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetRostersUnofficialDownloadData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetRostersUnofficialDownloadResponse,
    GetRostersUnofficialDownloadError,
    ThrowOnError
  >({
    ...options,
    url: "/rosters/unofficial/download",
  });
};

/**
 * Starts (creates) a new game at a specified machine
 */
export const postGameStart = <ThrowOnError extends boolean = false>(
  options: Options<PostGameStartData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostGameStartResponse,
    PostGameStartError,
    ThrowOnError
  >({
    ...options,
    url: "/game/start",
  });
};

/**
 * get a game on specified machine
 */
export const getGameActive = <ThrowOnError extends boolean = false>(
  options: Options<GetGameActiveData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetGameActiveResponse,
    GetGameActiveError,
    ThrowOnError
  >({
    ...options,
    url: "/game/active",
  });
};

/**
 * Replaces the home and/or away lineup of the game currently active on a machine. Permissioned on the requesting user being able to tag on that machine. The machine is taken from the machineUuid query parameter or from fieldUuid in the body; if both are given they must match. Lineups omitted from the body are kept, existing substitutions are cleared, a full game update is pushed over WebSocket, and a lineupUpdate event broker message is emitted.
 *
 */
export const postGameActiveLineups = <ThrowOnError extends boolean = false>(
  options: Options<PostGameActiveLineupsData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostGameActiveLineupsResponse,
    PostGameActiveLineupsError,
    ThrowOnError
  >({
    ...options,
    url: "/game/active/lineups",
  });
};

/**
 * Substitutes a player in a running game
 */
export const postGameByGameIdSubstitute = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostGameByGameIdSubstituteData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostGameByGameIdSubstituteResponse,
    PostGameByGameIdSubstituteError,
    ThrowOnError
  >({
    ...options,
    url: "/game/{game_id}/substitute",
  });
};

/**
 * Ends a running game
 */
export const postGameByGameIdEnd = <ThrowOnError extends boolean = false>(
  options: Options<PostGameByGameIdEndData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostGameByGameIdEndResponse,
    PostGameByGameIdEndError,
    ThrowOnError
  >({
    ...options,
    url: "/game/{game_id}/end",
  });
};

/**
 * Edit game times
 */
export const postGameByGameIdEditTimes = <ThrowOnError extends boolean = false>(
  options: Options<PostGameByGameIdEditTimesData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostGameByGameIdEditTimesResponse,
    PostGameByGameIdEditTimesError,
    ThrowOnError
  >({
    ...options,
    url: "/game/{game_id}/edit-times",
  });
};

/**
 * Download game data in CSV format
 */
export const getGameByGameIdCsv = <ThrowOnError extends boolean = false>(
  options: Options<GetGameByGameIdCsvData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetGameByGameIdCsvResponse,
    GetGameByGameIdCsvError,
    ThrowOnError
  >({
    ...options,
    url: "/game/{game_id}/csv",
  });
};

/**
 * Download game data in JSON format
 */
export const getGameByGameIdEvents = <ThrowOnError extends boolean = false>(
  options: Options<GetGameByGameIdEventsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetGameByGameIdEventsResponse,
    GetGameByGameIdEventsError,
    ThrowOnError
  >({
    ...options,
    url: "/game/{game_id}/events",
  });
};

/**
 * Trigger report generation via Smartpark Reports API
 */
export const postGameByGameIdReport = <ThrowOnError extends boolean = false>(
  options: Options<PostGameByGameIdReportData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostGameByGameIdReportResponse,
    PostGameByGameIdReportError,
    ThrowOnError
  >({
    ...options,
    url: "/game/{game_id}/report",
  });
};

/**
 * Get list of users in an organization
 */
export const getOrganizationsByOrgIdUsers = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetOrganizationsByOrgIdUsersData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetOrganizationsByOrgIdUsersResponse,
    GetOrganizationsByOrgIdUsersError,
    ThrowOnError
  >({
    ...options,
    url: "/organizations/{org_id}/users",
  });
};

/**
 * Get Machines Associated to an Organization
 */
export const getOrganizationsByOrgIdMachines = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetOrganizationsByOrgIdMachinesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetOrganizationsByOrgIdMachinesResponse,
    GetOrganizationsByOrgIdMachinesError,
    ThrowOnError
  >({
    ...options,
    url: "/organizations/{org_id}/machines",
  });
};

/**
 * Get Teams Associated with an Organization
 */
export const getOrganizationsByOrgIdOfficialTeam = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetOrganizationsByOrgIdOfficialTeamData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetOrganizationsByOrgIdOfficialTeamResponse,
    GetOrganizationsByOrgIdOfficialTeamError,
    ThrowOnError
  >({
    ...options,
    url: "/organizations/{org_id}/official-team",
  });
};

/**
 * Associate Machines to Organizations
 */
export const postOrganizationsByOrgIdAssociateMachines = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostOrganizationsByOrgIdAssociateMachinesData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostOrganizationsByOrgIdAssociateMachinesResponse,
    PostOrganizationsByOrgIdAssociateMachinesError,
    ThrowOnError
  >({
    ...options,
    url: "/organizations/{org_id}/associate-machines",
  });
};

/**
 * Associate Teams to Organizations
 */
export const postOrganizationsByOrgIdAssociateOfficialTeams = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostOrganizationsByOrgIdAssociateOfficialTeamsData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).post<
    PostOrganizationsByOrgIdAssociateOfficialTeamsResponse,
    PostOrganizationsByOrgIdAssociateOfficialTeamsError,
    ThrowOnError
  >({
    ...options,
    url: "/organizations/{org_id}/associate-official-teams",
  });
};

/**
 * Delete an organization
 */
export const postOrganizationsByOrgIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostOrganizationsByOrgIdDeleteData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostOrganizationsByOrgIdDeleteResponse,
    PostOrganizationsByOrgIdDeleteError,
    ThrowOnError
  >({
    ...options,
    url: "/organizations/{org_id}/delete",
  });
};

/**
 * Verify an organization invitation. Requires MAGNUS_SUPER_ADMIN approval and must be different from the inviting admin.
 */
export const postOrganizationsByOrgIdVerify = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostOrganizationsByOrgIdVerifyData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostOrganizationsByOrgIdVerifyResponse,
    PostOrganizationsByOrgIdVerifyError,
    ThrowOnError
  >({
    ...options,
    url: "/organizations/{org_id}/verify",
  });
};

/**
 * Get list of organizations
 */
export const getOrganizationsSearch = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrganizationsSearchData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetOrganizationsSearchResponse,
    GetOrganizationsSearchError,
    ThrowOnError
  >({
    ...options,
    url: "/organizations/search",
  });
};

/**
 * Get a list of all organizations for a dropdown
 */
export const getOrganizations = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetOrganizationsResponse,
    GetOrganizationsError,
    ThrowOnError
  >({
    ...options,
    url: "/organizations",
  });
};

/**
 * Creates a new Organization
 */
export const postOrganizationsCreate = <ThrowOnError extends boolean = false>(
  options: Options<PostOrganizationsCreateData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostOrganizationsCreateResponse,
    PostOrganizationsCreateError,
    ThrowOnError
  >({
    ...options,
    url: "/organizations/create",
  });
};

/**
 * Updates an Organization
 */
export const postOrganizationsByOrgIdEdit = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostOrganizationsByOrgIdEditData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostOrganizationsByOrgIdEditResponse,
    PostOrganizationsByOrgIdEditError,
    ThrowOnError
  >({
    ...options,
    url: "/organizations/{org_id}/edit",
  });
};

/**
 * Get the default payment method for an organization
 */
export const getOrganizationsByOrgIdBillingPaymentMethod = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetOrganizationsByOrgIdBillingPaymentMethodData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).get<
    GetOrganizationsByOrgIdBillingPaymentMethodResponse,
    GetOrganizationsByOrgIdBillingPaymentMethodError,
    ThrowOnError
  >({
    ...options,
    url: "/organizations/{org_id}/billing/payment-method",
  });
};

/**
 * Save a payment method as the default for an organization
 */
export const postOrganizationsByOrgIdBillingPaymentMethod = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostOrganizationsByOrgIdBillingPaymentMethodData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).post<
    PostOrganizationsByOrgIdBillingPaymentMethodResponse,
    PostOrganizationsByOrgIdBillingPaymentMethodError,
    ThrowOnError
  >({
    ...options,
    url: "/organizations/{org_id}/billing/payment-method",
  });
};

/**
 * Create a Stripe SetupIntent for saving a new payment method
 */
export const postOrganizationsByOrgIdBillingSetupIntent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostOrganizationsByOrgIdBillingSetupIntentData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).post<
    PostOrganizationsByOrgIdBillingSetupIntentResponse,
    PostOrganizationsByOrgIdBillingSetupIntentError,
    ThrowOnError
  >({
    ...options,
    url: "/organizations/{org_id}/billing/setup-intent",
  });
};

/**
 * Delete an unofficial player from an organization
 * Delete an unofficial player from an organization and from the organization's rosters they are in
 */
export const postOrganizationsByOrgIdPlayersByPlayerIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostOrganizationsByOrgIdPlayersByPlayerIdDeleteData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).post<
    PostOrganizationsByOrgIdPlayersByPlayerIdDeleteResponse,
    PostOrganizationsByOrgIdPlayersByPlayerIdDeleteError,
    ThrowOnError
  >({
    ...options,
    url: "/organizations/{org_id}/players/{player_id}/delete",
  });
};

/**
 * Creates an invitation link
 */
export const postUsersInvitationsCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostUsersInvitationsCreateData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostUsersInvitationsCreateResponse,
    PostUsersInvitationsCreateError,
    ThrowOnError
  >({
    ...options,
    url: "/users/invitations/create",
  });
};

/**
 * Get details about specified token_code
 */
export const getUsersInvitationsByTokenCode = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetUsersInvitationsByTokenCodeData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetUsersInvitationsByTokenCodeResponse,
    GetUsersInvitationsByTokenCodeError,
    ThrowOnError
  >({
    ...options,
    url: "/users/invitations/{token_code}",
  });
};

/**
 * Redeem invitation for the current user
 */
export const postUsersInvitationsByTokenCodeRedeem = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostUsersInvitationsByTokenCodeRedeemData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostUsersInvitationsByTokenCodeRedeemResponse,
    PostUsersInvitationsByTokenCodeRedeemError,
    ThrowOnError
  >({
    ...options,
    url: "/users/invitations/{token_code}/redeem",
  });
};

/**
 * Retrieves unverified organization invitations
 */
export const getInvitationsOrganizationsUnverified = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetInvitationsOrganizationsUnverifiedResponse,
    GetInvitationsOrganizationsUnverifiedError,
    ThrowOnError
  >({
    ...options,
    url: "/invitations/organizations/unverified",
  });
};

/**
 * Add players to unofficial rosters
 */
export const postRostersByRosterIdPlayers = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostRostersByRosterIdPlayersData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostRostersByRosterIdPlayersResponse,
    PostRostersByRosterIdPlayersError,
    ThrowOnError
  >({
    ...options,
    url: "/rosters/{roster_id}/players",
  });
};

/**
 * Edits a player within an organization's roster
 */
export const postOrganizationsByOrgIdPlayersByPlayerExternalIdEdit = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostOrganizationsByOrgIdPlayersByPlayerExternalIdEditData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).post<
    PostOrganizationsByOrgIdPlayersByPlayerExternalIdEditResponse,
    PostOrganizationsByOrgIdPlayersByPlayerExternalIdEditError,
    ThrowOnError
  >({
    ...options,
    url: "/organizations/{org_id}/players/{player_external_id}/edit",
  });
};

/**
 * Get list of public authorities
 */
export const getAuthoritiesPublic = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetAuthoritiesPublicResponse,
    GetAuthoritiesPublicError,
    ThrowOnError
  >({
    ...options,
    url: "/authorities/public",
  });
};

/**
 * Gets a list of top performers for a team in a time period.
 */
export const getTeamsByTeamExternalIdLeaderboard = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetTeamsByTeamExternalIdLeaderboardData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetTeamsByTeamExternalIdLeaderboardResponse,
    GetTeamsByTeamExternalIdLeaderboardError,
    ThrowOnError
  >({
    ...options,
    url: "/teams/{team_external_id}/leaderboard",
  });
};

/**
 * Send a challenge request to the machine
 */
export const postBalltrackerByMachineUuidChallenge = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostBalltrackerByMachineUuidChallengeData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostBalltrackerByMachineUuidChallengeResponse,
    PostBalltrackerByMachineUuidChallengeError,
    ThrowOnError
  >({
    ...options,
    url: "/balltracker/{machine_uuid}/challenge",
  });
};

/**
 * Get the blocked status of the machine
 */
export const getBalltrackerByMachineUuidBlocked = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetBalltrackerByMachineUuidBlockedData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetBalltrackerByMachineUuidBlockedResponse,
    GetBalltrackerByMachineUuidBlockedError,
    ThrowOnError
  >({
    ...options,
    url: "/balltracker/{machine_uuid}/blocked",
  });
};

/**
 * Enable blocked on the machine (block time range for led smart socket)
 */
export const postBalltrackerByMachineUuidBlocked = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostBalltrackerByMachineUuidBlockedData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostBalltrackerByMachineUuidBlockedResponse,
    PostBalltrackerByMachineUuidBlockedError,
    ThrowOnError
  >({
    ...options,
    url: "/balltracker/{machine_uuid}/blocked",
  });
};

/**
 * Delete blocked on the machine (and end on cloud)
 */
export const deleteBalltrackerByMachineUuidBlocked = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteBalltrackerByMachineUuidBlockedData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeleteBalltrackerByMachineUuidBlockedResponse,
    DeleteBalltrackerByMachineUuidBlockedError,
    ThrowOnError
  >({
    ...options,
    url: "/balltracker/{machine_uuid}/blocked",
  });
};

/**
 * Get the stat-tracking status of the machine
 */
export const getBalltrackerByMachineUuidStatTracking = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetBalltrackerByMachineUuidStatTrackingData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetBalltrackerByMachineUuidStatTrackingResponse,
    GetBalltrackerByMachineUuidStatTrackingError,
    ThrowOnError
  >({
    ...options,
    url: "/balltracker/{machine_uuid}/stat-tracking",
  });
};

/**
 * Enable stat-tracking on the machine
 */
export const postBalltrackerByMachineUuidStatTracking = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostBalltrackerByMachineUuidStatTrackingData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostBalltrackerByMachineUuidStatTrackingResponse,
    PostBalltrackerByMachineUuidStatTrackingError,
    ThrowOnError
  >({
    ...options,
    url: "/balltracker/{machine_uuid}/stat-tracking",
  });
};

/**
 * Delete stat-tracking on the machine (and end on cloud)
 */
export const deleteBalltrackerByMachineUuidStatTracking = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteBalltrackerByMachineUuidStatTrackingData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).delete<
    DeleteBalltrackerByMachineUuidStatTrackingResponse,
    DeleteBalltrackerByMachineUuidStatTrackingError,
    ThrowOnError
  >({
    ...options,
    url: "/balltracker/{machine_uuid}/stat-tracking",
  });
};

/**
 * Get the umpire-assist status of the machine
 */
export const getBalltrackerByMachineUuidUmpireAssist = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetBalltrackerByMachineUuidUmpireAssistData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetBalltrackerByMachineUuidUmpireAssistResponse,
    GetBalltrackerByMachineUuidUmpireAssistError,
    ThrowOnError
  >({
    ...options,
    url: "/balltracker/{machine_uuid}/umpire-assist",
  });
};

/**
 * Enable umpire-assist on the machine
 */
export const postBalltrackerByMachineUuidUmpireAssist = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostBalltrackerByMachineUuidUmpireAssistData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostBalltrackerByMachineUuidUmpireAssistResponse,
    PostBalltrackerByMachineUuidUmpireAssistError,
    ThrowOnError
  >({
    ...options,
    url: "/balltracker/{machine_uuid}/umpire-assist",
  });
};

/**
 * Delete umpire assist on the machine (and end on cloud)
 */
export const deleteBalltrackerByMachineUuidUmpireAssist = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteBalltrackerByMachineUuidUmpireAssistData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).delete<
    DeleteBalltrackerByMachineUuidUmpireAssistResponse,
    DeleteBalltrackerByMachineUuidUmpireAssistError,
    ThrowOnError
  >({
    ...options,
    url: "/balltracker/{machine_uuid}/umpire-assist",
  });
};

/**
 * Get the unified status of a machine
 */
export const getBalltrackerByMachineUuidUnified = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetBalltrackerByMachineUuidUnifiedData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetBalltrackerByMachineUuidUnifiedResponse,
    GetBalltrackerByMachineUuidUnifiedError,
    ThrowOnError
  >({
    ...options,
    url: "/balltracker/{machine_uuid}/unified",
  });
};

/**
 * Set the unified config of a BallTracker
 */
export const postBalltrackerByMachineUuidUnified = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostBalltrackerByMachineUuidUnifiedData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostBalltrackerByMachineUuidUnifiedResponse,
    PostBalltrackerByMachineUuidUnifiedError,
    ThrowOnError
  >({
    ...options,
    url: "/balltracker/{machine_uuid}/unified",
  });
};

/**
 * Get the strike zone configuration for a machine
 */
export const getBalltrackerByMachineUuidStrikeZone = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetBalltrackerByMachineUuidStrikeZoneData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetBalltrackerByMachineUuidStrikeZoneResponse,
    GetBalltrackerByMachineUuidStrikeZoneError,
    ThrowOnError
  >({
    ...options,
    url: "/balltracker/{machine_uuid}/strike-zone",
  });
};

/**
 * Set the strike zone configuration for a machine. Please use ParkConfig instead.
 */
export const postBalltrackerByMachineUuidStrikeZone = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostBalltrackerByMachineUuidStrikeZoneData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostBalltrackerByMachineUuidStrikeZoneResponse,
    PostBalltrackerByMachineUuidStrikeZoneError,
    ThrowOnError
  >({
    ...options,
    url: "/balltracker/{machine_uuid}/strike-zone",
  });
};

/**
 * Get strike zone presets for a given sport
 */
export const getBalltrackerStrikeZoneBySport = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetBalltrackerStrikeZoneBySportData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetBalltrackerStrikeZoneBySportResponse,
    GetBalltrackerStrikeZoneBySportError,
    ThrowOnError
  >({
    ...options,
    url: "/balltracker/strike-zone/{sport}",
  });
};

/**
 * Get schedules
 */
export const getSchedule = <ThrowOnError extends boolean = false>(
  options?: Options<GetScheduleData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetScheduleResponse,
    GetScheduleError,
    ThrowOnError
  >({
    ...options,
    url: "/schedule",
  });
};

/**
 * Get schedule by ID
 */
export const getScheduleByScheduleUuid = <ThrowOnError extends boolean = false>(
  options: Options<GetScheduleByScheduleUuidData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetScheduleByScheduleUuidResponse,
    GetScheduleByScheduleUuidError,
    ThrowOnError
  >({
    ...options,
    url: "/schedule/{scheduleUuid}",
  });
};

/**
 * Send in external schedule
 */
export const postScheduleExternal = <ThrowOnError extends boolean = false>(
  options: Options<PostScheduleExternalData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostScheduleExternalResponse,
    PostScheduleExternalError,
    ThrowOnError
  >({
    ...options,
    url: "/schedule/external",
  });
};

/**
 * Send in external schedule
 */
export const postScheduleInternal = <ThrowOnError extends boolean = false>(
  options: Options<PostScheduleInternalData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PostScheduleInternalResponse,
    PostScheduleInternalError,
    ThrowOnError
  >({
    ...options,
    url: "/schedule/internal",
  });
};
